var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChecked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 149,
    height: 114,
    viewBox: "0 0 149 114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#79BEAA",
    fillRule: "evenodd",
    stroke: "#FFF",
    strokeWidth: 4,
    d: "M143.916 3.683c-2.084-.297-5.36-.892-10.721-1.19-5.361-.595-8.935-.595-10.722-.298-1.787.298-5.063 2.083-9.828 5.06-4.765 2.975-11.913 8.926-21.741 17.556-9.53 8.63-19.061 18.152-27.996 27.972-8.34 9.225-16.38 19.045-24.124 29.46-2.978-8.63-5.956-14.879-9.232-18.747-3.574-4.166-6.85-6.845-10.126-7.44-2.383-.595-5.659 0-9.829 1.786-4.17 1.785-6.85 4.166-7.445 6.844-.596 2.083.595 5.059 2.978 9.225 4.467 7.737 8.34 15.473 11.317 23.508 1.787 5.059 3.276 8.034 3.872 9.225.596 1.19 2.383 2.38 9.233 4.166 3.574.892 6.254 1.19 8.637 1.19 2.382 0 3.871-.595 5.063-1.488 1.787-1.488 5.063-5.654 10.423-13.39 12.807-18.45 27.4-35.412 43.78-51.183 16.381-15.474 30.677-27.08 42.887-33.924 3.872-2.083 4.468-2.678 4.766-2.678.893-.595 1.19-1.488 1.489-2.38 0-1.19-.596-2.679-2.68-3.274h0z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.ebd490fa.svg";
export { ForwardRef as ReactComponent };